function initExpandToggle(box, toggleSelector, expandedTextSelector, expandedClass) {
    const toggle = box.querySelector(toggleSelector);
    const expandedText = box.querySelector(expandedTextSelector);

    if (toggle && expandedText) {
        toggle.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            const isExpanded = expandedText.getAttribute('data-expanded') === 'true';

            if (isExpanded) {
                expandedText.setAttribute('data-expanded', 'false');
                box.classList.remove(expandedClass);
            } else {
                expandedText.setAttribute('data-expanded', 'true');
                box.classList.add(expandedClass);
            }
        });
    }
}

export default function initializeBoxElement() {
    document.querySelectorAll('.box-element').forEach(function (box) {
        initExpandToggle(box, '.box-element__toggle', '.box-element__expanded-text', 'box-element--expanded');
    });

    document.querySelectorAll('.box-element-icon').forEach(function (box) {
        initExpandToggle(box, '.box-element-icon__toggle', '.box-element-icon__expanded-text', 'box-element-icon--expanded');
    });

    document.querySelectorAll('.timeline-item').forEach(function (box) {
        initExpandToggle(box, '.timeline-item__toggle', '.timeline-item__expanded-text', 'timeline-item--expanded');
    });
}
